export const moveListItem = <T>(items: T[], item: T, to: number) => {
  const arr = [...items];
  const source = arr.findIndex((subject) => subject === item);
  if (source === -1) return arr;
  const [movedItem] = arr.splice(source, 1);
  arr.splice(to, 0, movedItem!);
  return arr;
};
